interface DetailLabelProps {
  icon: React.ComponentType<{ className?: string }>;
  text: string;
}

export function DetailLabel({ icon: Icon, text }: DetailLabelProps) {
  return (
    <div className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground mb-1">
      <Icon className="h-3.5 w-3.5" />
      {text}
    </div>
  );
}

interface DetailFieldProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value: string;
}

export function DetailField({ icon, label, value }: DetailFieldProps) {
  return (
    <div>
      <DetailLabel icon={icon} text={label} />
      <p className="text-sm break-words">{value}</p>
    </div>
  );
}
